import { resolveDirection, type TranslationParams, type TextDirection } from "@yjsgames/i18n";
import { translator, type LanguageCode } from "./locales.js";

export type { TextDirection };

/** 현재 언어. 번역 엔진(@yjsgames/i18n Translator)의 활성 locale을 그대로 사용. */
export function getLanguage(): LanguageCode {
  return translator.getLocale() as LanguageCode;
}

export function setLanguage(lang: LanguageCode): void {
  translator.setLocale(lang);
}

/**
 * 현재(또는 지정) 언어의 텍스트 방향 — RTL 언어(아랍/히브리 등)면 `"rtl"`, 그 외 `"ltr"`.
 * 판정은 @yjsgames/i18n `resolveDirection`(RTL 언어코드 집합 SSoT)에 위임.
 */
export function getTextDirection(lang?: LanguageCode): TextDirection {
  return resolveDirection({ locale: lang ?? getLanguage() });
}

export type TParams = TranslationParams;

/**
 * 현지화 키 → 현재 언어 문자열.
 * - 패키지 Translator가 lookup(현재→fallback ko→key) + `{token}` 보간 담당.
 * - 앱 전용: 리터럴 `\n`(TSV 셀의 백슬래시+n) → 실제 줄바꿈 (Phaser 멀티라인 라벨).
 */
export function t(key: string, params?: TParams): string {
  return translator.t(key, params).replace(/\\n/g, "\n");
}
